<template>
    <div class="szolgaltatas_box_container" v-show="ITEMS.length>0">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcDialog_KarOsszesito ref="DialogKarOsszesito" v-on:showfile="ShowFile" ></GrcDialog_KarOsszesito>
    <GrcWidgetLoading v-show="IsWidgetLoading" />
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDocUtils ref="DocUtils"></GrcDocUtils>


    <div class="szolgaltatas_box_wrapper" v-show="IsWidgetLoading==false">

        <br><br>
        <h2 class="painted_header_h2 color3"><span><b>Egyéb keretek</b></span></h2>
        <br>

        <div class="section_cont">
            <span v-show="ITEMS.length==0">Önnek nincs egyéb keret igénylése<br><br></span>

            <div class="item_list_cont">
                <div class="item_list_col50" v-for="(item, index)  in ITEMS" v-bind:key="index">

                        <div class="item_list_col50_inner">
                            <div class="item_list_header_left" v-html="item.Ellatas"></div>
                            <div class="item_list_header_right">
                                <span class="btnOsszesito" @click="ShowOsszesito(index)" title="Összesítő megjelenítése">
                                    <i class="fal fa-file-alt" style="font-size: 20px; margin:0px 4px;"></i>
                                    {{item.Azonosito}}
                                </span>
                            </div>




                            <div class="item_content_outer" style="padding:4px;" v-show="item.KarID==0">
                                    <div class="field_text">
                                        <span style="display:inline-block; width:100px; font-weight:500; color:#222;">Bejelentés:</span>{{item.BejelDatum}}
                                    </div>
                                    <div class="field_text">
                                        <span style="display:inline-block; width:100px; font-weight:500; color:#222;">Státusz:</span>{{item.Statusz}}
                                    </div>

                                    <div class="field_text" style="text-align:justify;" v-html="item.IgenyVizsgalat" v-show="item.IgenyVizsgalat!=''"></div>                                


                                    <div style="width:100%; padding:0px; padding-top:4px;">

                                        <span @click="ShowOsszesito(index)" class="painted_linkbutton2 color3" style="margin: 4px 4px 4px 0px;">
                                            <span><i class="fal fa-file-alt" style="margin-right: 4px;"></i>Részletek</span>
                                        </span>                                        

                                        <span v-for="(btnitem)  in HIANYBUTTONS" v-bind:key="btnitem.id"
                                            v-show="btnitem.KritikusIgenyID==item.IgenyID"
                                            @click="HianyButtonClick(btnitem.id)"
                                            class="painted_linkbutton2 color4" style="margin: 4px 4px 4px 0px;"
                                            >
                                            <span v-html="btnitem.ButtonText"></span>
                                        </span>                                        

                                    </div>

                            </div>


                        </div>
                </div>
            </div>

            <div style="width:100%; text-align: center; margin: 20px 0px 10px 0px;" v-show="SzamlaEngedely==1">

                <a href="kritikus-szamla-feltoltes" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                    <span><i class="fal fa-plus" style="margin-right: 4px;"></i>Számla beküldés kritikus keret terhére</span>
                </a>                                        

            </div>

        </div>


    </div>

    </div>
</template>

<script>

import axios from "axios";
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcWidgetLoading from '../GrcComponents/GrcWidgetLoading.vue'
import GrcDialog_KarOsszesito from '../GrcComponents/GrcDialog_KarOsszesito.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocUtils from '../GrcComponents/GrcDocUtils.vue'

export default {
  name: 'frmDashboard_KritikusIgenyek',
  components: {
      GrcDB,
      GrcButton,
      GrcDialog,
      GrcWidgetLoading,
      GrcDialog_KarOsszesito,
      GrcDocDisplayer,
      GrcDocUtils,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_KritikusIgenyek",
          IsWidgetLoading: false,

          ITEMS:[],
          HIANYBUTTONS:[],
          SZAMLAK:[],
          SzamlaEngedely:0,
      }
  },
  model: {
  },  
  methods:{

      async ShowFile(pKepID, pTipus)
      {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sSessionID: "[APPSESSIONID]",
            iKepID: pKepID,
            sTipus: pTipus,
        };
        //console.log(QP);

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_GetDoc", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            alert(Q.APPERR[0].ERR);
            //this.$emit("handlecommerror", Q.APPERR[0].ERR);
            return;
        }
        
        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT.length == 0)
        {
            this.ShowResult("Hiba a dokumentum lekérdezésekor!", 400, 200);
            return;
        }
        
        if (Q.RESULT[0].DocData == "")
        {
            this.ShowResult("Hiba a dokumentum lekérdezésekor!", 400, 200);
            return;
        }

        var docb64 = Q.RESULT[0].DocData;
        var docfn = Q.RESULT[0].FileNev;// eredeti fájlnév
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi

        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        //grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            alert(docresult);
            //this.ShowResult(docresult, 400, 200);
        }

      },

      Frissites_click(pIndex)
      {
          this.Init();
      },

      IdopontFoglalas_click(pIndex)
      {
        let FoglUrl = this.ITEMS[pIndex].UgyfelLink;

        if (FoglUrl != "")
        {
            this.ITEMS[pIndex].FrissitesSzukseges = 1;
            window.open(FoglUrl, "_blank");
        }
      },

      IdosavModositas_click(pIndex)
      {
        document.location = "idosavmodositas?KARID="+this.ITEMS[pIndex].KarID+"&RETURNALIAS=dashboard";
      },



      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      SetToDefault()
      {
        this.IsWidgetLoading = true;
      },

      async btnLemondas_click(pIndex)
      {
        this.$refs.GRCDB.ShowLoading(false);

        let pKarID = this.ITEMS[pIndex].KarID;

        var QP = {
            sSessionID: "[APPSESSIONID]",
            iUgyfelID: gDashboardUgyfelID,
            iKarID: pKarID,
        };
        var Q;

        var Q_Sikeres = false;

        await this.$refs.GRCDB.GetData("frmDashboard_KritikusIgenyek_LemondasPopup", QP).then(res => { 
            Q = res; 

            //console.log(Q);

            if (Q.APPERR[0].ERR != "")
            {
                this.$refs.GRCDB.HideLoading();
                alert(Q.APPERR[0].ERR);
                return;
            }
            else { Q_Sikeres = true; }
        });

        this.$refs.GRCDB.HideLoading();

        if (Q_Sikeres == false) { return; }

        var DialogResult = "";

        let pButtons = [];
        if (Q.RESULT[0].VeglegesGomb == 1)
        {
            pButtons.push({text: "Lemondás", value: "LEMONDAS", color:"blue", width:"100px", default: false});
        }
        if (Q.RESULT[0].ModositasGomb == 1)
        {
            pButtons.push({text: "Módosítás", value: "MODOSITAS", color:"blue", width:"100px", default: false});
        }

        pButtons.push({text: "Mégsem", value: "CANCEL", color:"grey", width:"90px", default: true});

        let pText = "<div style='text-align:justify; box-sizing:border-box;width:100%;'>"+Q.RESULT[0].Szoveg+"</div>";
        let pTitle = "<i class='fal fa-question-circle' style='margin-right:6px;'></i>" + "Lemondás/módosítás";
        var params = { title: pTitle, text: pText, color: grccomp_dialog_default_color(), width:400, height:180, padding_top:150,
            buttons: pButtons,
        };

        params.height = 330;
        params.width = 600;
        params.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { params.width = grccomp_getScreenSize().width-20; }
        await this.$refs.Dialog.ShowDialog(params).then(res => 
        { 
            DialogResult = res; 
        });              
        
        //console.log(DialogResult);

        if (DialogResult == "CANCEL") { return; }

        let ActionValue = DialogResult;


        this.$refs.GRCDB.ShowLoading(false);

        //console.log(QP);
        var QP = {
            sSessionID: "[APPSESSIONID]",
            iUgyfelID: gDashboardUgyfelID,
            iKarID: pKarID,
            sLemondasTipus: ActionValue,
        };
        var Q;

        Q_Sikeres = false;

        await this.$refs.GRCDB.GetData("frmDashboard_KritikusIgenyek_Lemondas", QP).then(res => { 
            Q = res; 

            //console.log(Q);

            if (Q.APPERR[0].ERR != "")
            {
                this.$refs.GRCDB.HideLoading();
                alert(Q.APPERR[0].ERR);
                return;
            }
            else { Q_Sikeres = true; }
        });

        this.$refs.GRCDB.HideLoading();

        if (Q_Sikeres == false) { return; }


        if (ActionValue == "LEMONDAS")
        {
            this.Init();
            return;
        }

        this.ITEMS[pIndex].UgyfelLink = Q.RESULT[0].UgyfelLink;
        this.ITEMS[pIndex].FrissitesSzukseges = 1;

        if (Q.RESULT[0].IdopontTipusID == 2) // online
        {
            this.IdopontFoglalas_click(pIndex);
            return;
        }

        // itt akkor van, ha ELLA, azaz (Q.RESULT[0].IdopontTipus == 3)

        //grcmain_GetTextBookItem("frmDashboard", "LemondasPopup2");

        DialogResult = "";

        pText = "<div style='text-align:justify; box-sizing:border-box;width:100%;'>"+grcmain_GetTextBookItem("frmDashboard", "LemondasPopup2")+"</div>";
        pTitle = "<i class='fas fa-info-circle' style='margin-right:6px;'></i>" + "Információ";
        params = { title: pTitle, text: pText, color: grccomp_dialog_default_color(), width:400, height:180, padding_top:150,
            buttons: [
              {text: "Foglalok magamnak", value: "FOGLALAS", color:"blue", width:"170px", default: false} ,
              {text: "Idősáv megadás", value: "IDOSAV", color:"blue", width:"140px", default: false}
            ],
        };

        params.height = 300;
        params.width = 600;
        params.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { params.width = grccomp_getScreenSize().width-20; }
        await this.$refs.Dialog.ShowDialog(params).then(res => 
        { 
            DialogResult = res; 
        });    
        
        if (DialogResult == "FOGLALAS")
        {
            this.IdopontFoglalas_click(pIndex);
            await this.Init();
            for(let i=0; i<this.ITEMS.length; i++)
            {
                if (this.ITEMS[i].KarID == pKarID)
                {
                    this.ITEMS[i].FrissitesSzukseges = 1;
                }
            }
            return;
        }

        if (DialogResult == "IDOSAV")
        {
            this.IdosavModositas_click(pIndex);
            return;
        }



      },

      async OnreszBefizetes(pIndex)
      {
          let pUrl = this.ITEMS[pIndex].OnreszUrl;
          if (pUrl == "") { return; }

          document.location = pUrl;

      },

      async ShowOsszesito(pIndex)
      {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sSessionID: "[APPSESSIONID]",
            iIgenyID: this.ITEMS[pIndex].IgenyID
        };
        var Q;

        await this.$refs.GRCDB.GetData("frmDashboard_GetKritikusIgenyOsszesito", QP).then(res => { 
            Q = res; 

            //console.log(Q);

            if (Q.APPERR[0].ERR != "")
            {
                this.$refs.GRCDB.HideLoading();
                alert(Q.APPERR[0].ERR);
                return;
            }
            this.$refs.GRCDB.HideLoading();
        });

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults("Összesítő - "+this.ITEMS[pIndex].Azonosito, Q.RESULT[0].Szoveg);             
        p.height = 600;
        p.width = 600;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.DialogKarOsszesito.ShowDialog(p, Q.FILES).then(res => 
        { 
            DialogResult = res; 
        });               


      },

      btnUtvonal_click(pIndex)
      {
        let s = "";
        s = this.ITEMS[pIndex].Idopont_SzolgCim;
        if (s == "") { s = this.ITEMS[pIndex].Idopont_SzolgNev; }


          if (s != "")
          {
            s = "https://maps.google.com/?q="+s;
            window.open(s);
          }
      },

      HianyButtonClick(pLevelID)
      {
        document.location = "kritikus-hianypotlas?MAILID="+pLevelID;
      },

      btnSzamlaFeltoltesClick(pKarID)
      {
        document.location = "szamlafeltoltes?KARID="+pKarID;
      },

      async Init()
      {
        this.SzamlaEngedely = 0;
         this.ITEMS = [];
         this.HIANYBUTTONS = [];
         this.SZAMLAK = [];

        this.IsWidgetLoading = true;

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: gDashboardUgyfelID,
        };
        var Q;

        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_GetData", QP).then(res => { 
            Q = res; 
            this.IsWidgetLoading = false;

            if (Q.APPERR[0].ERR != "")
            {
                //alert(Q.APPERR[0].ERR);
                return;
            }

            //console.log(Q.LIST);
            //console.log(Q);

            this.ITEMS = Q.LIST;
            this.HIANYBUTTONS = Q.HIANYBUTTONS;
            this.SZAMLAK = Q.SZAMLALISTA;
            this.SzamlaEngedely = Q.MISC[0].SzamlaEngedely;
        });
      },


      

    /*
    async ShowInfo(pText)
    {
        window.open(pText, "_blank");
    },
    */



  },
  created()
  {

  },
  mounted()
  {
      

  }

}


</script>


<style scoped>

.section_cont
{
    width:100%;
    box-sizing: border-box;
    padding:0px 0px;
}

.item_list_cont
{
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    padding-bottom: 10px;
}

.item_content_outer
{
    width: 100%;
    box-sizing: border-box;
}

.item_content_outer_col50
{
    width: 50%;
    box-sizing: border-box;
    display:inline-block;
    margin:0px;
    padding:8px 8px;
    vertical-align: top;
}

.item_list_col50
{
    width: 100%;
    box-sizing: border-box;
    display:inline-block;
    padding:10px 0px;
    vertical-align: top;
    margin:0px;
}

.item_list_col50_inner
{
    width: 100%;
    box-sizing: border-box;
    display:block;
    margin:0px;
    border:solid 1px #d6d6d6;
    border-radius: 3px;
    min-height:160px;
    background-color: rgba(255,255,255,0.5);
    box-shadow: 0px 0px 20px #00000032;

}

.item_list_header_left
{
    width: 70%;
    box-sizing: border-box;
    display:inline-block;
    padding:4px;
    vertical-align: top;
    margin:0px;
    background-color: #e6e7e8;
    color:#000;
    font-weight:500;
    font-size:15px;
    line-height:20px;
    text-transform: uppercase;
    border-bottom-right-radius: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.item_list_header_right
{
    width: 30%;
    box-sizing: border-box;
    display:inline-block;
    padding:4px;
    vertical-align: top;
    margin:0px;
    color:var(--themecolor3);
    font-weight:500;
    font-size:15px;
    line-height:20px;
    text-align: right;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;    
}

.field_label
{
    width: 80px;
    box-sizing: border-box;
    color:#222;
    font-family: 'CmsDefault';
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    font-weight: 500;
    display:inline-block;
}

.field_text
{
    box-sizing: border-box;
    color:#444;
    font-family: 'CmsDefault';
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    margin-bottom: 6px;
}

.btn_cont
{
    width:100%;
    box-sizing: border-box;
}

.btn
{
    display:inline-block;
    box-sizing: border-box;
    font-family: 'CmsDefault';
    font-size:13px;
    line-height: 13px;
    padding:8px;
    color:#fff;
    background-color: var(--themecolor3);
    cursor:pointer;
    border-radius: 3px;
    margin-right: 4px;
    margin-bottom: 2px;
}

.btn:hover
{
    opacity:0.8;
}

.btn2
{
    display:inline-block;
    box-sizing: border-box;
    font-family: 'CmsDefault';
    font-size:14px;
    line-height: 14px;
    padding:8px;
    background-color:#fff;
    color: var(--themecolor3);
    cursor:pointer;
    border-radius: 3px;
    margin-right: 4px;
    margin-bottom: 2px;
    border:solid 2px var(--themecolor3);
    font-weight: 500;
}

.btn2:hover
{
    opacity:0.8;
}



.szlaitem
{
    display:inline-block;
    box-sizing: border-box;
    font-family: 'CmsDefault';
    font-size:13px;
    line-height: 13px;
    padding:8px;
    color:#444;
    background-color: #fff;
    border-radius: 3px;
    margin-right: 4px;
    border: solid 1px #ccc;
    margin-bottom: 4px;
    cursor:pointer;
}

.szlaitem:hover
{
    color:#888;
    background-color: #fff;
    border: solid 1px #888;
}


.idopont_honap
{
    width:100%;
    box-sizing: border-box;
    background-color: var(--themecolor4);
    color: #fff;
    font-family: 'CmsDefault';
    font-size: 12px;
    line-height: 12px;
    padding:3px 0px;
    border-top-left-radius: 2px;
    text-align: center;
    font-weight: bold;
}

.idopont_nap
{
    width:100%;
    box-sizing: border-box;
    background-color: #fff;
    color: #222;
    font-family: 'CmsDefault';
    font-size: 20px;
    line-height: 20px;
    padding:15px 0px;
    text-align: center;
    font-weight: bold;
}

.idopont_ido
{
    width:90%;
    box-sizing: border-box;
    background-color: #fff;
    color: #222;
    font-family: 'CmsDefault';
    font-size: 12px;
    line-height: 12px;
    padding:3px 0px;
    text-align: center;
    border-bottom: dotted 1px #ccc;
    margin:0px auto;
}

.idopont_hetnap
{
    width:100%;
    box-sizing: border-box;
    background-color: #fff;
    color: #222;
    font-family: 'CmsDefault';
    font-size: 12px;
    line-height: 12px;
    padding:3px 0px;
    text-align: center;
    margin-bottom: 4px;
    font-weight: bold;
}

.btnOsszesito
{
    cursor:pointer;
    color:var(--themecolor3);
    font-weight: bold;
}

.btnOsszesito:hover
{
    opacity:0.8;
}


@media (max-width:1060px)
{
    .item_list_col50
    {
        width: 100%;
        box-sizing: border-box;
    }
}

@media (max-width:600px)
{
    .item_content_outer_col50
    {
        width: 100%;
        box-sizing: border-box;
    }

    .item_list_header_left
    {
        width:100%;
        border-bottom-right-radius: 0px;
        border-top-right-radius: 4px;
    }

    .item_list_header_right
    {
        width:100%;
        text-align: center;
        margin-top:8px;
    }
 
}






</style>